import React from "react";
import { useRoutes } from "react-router-dom";
import PayPage from "../component/pay-page";
import CreatePayPage from "../component/create-pay-page";

export const RouterWrapper = () => {
    const routes = useRoutes([
        {
            path: '/verifypayment',
            element: <CreatePayPage />
        },
        {
            path: '/paymentpage',
            element: <PayPage />
        }
    ]);

    return routes;
}